/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], function () {
	'use strict';
	// Temporary array of live widget feature specs. This can be used to quickly test a live widget feature without adding to the perspective collection
	// Example:
	// {
	// 	"containerId": "com.ibm.bi.dashboard.live-features",
	// 	"name": "summaryFeature",
	// 	"id": "com.ibm.bi.dashboard.live-features.summaryFeature",
	// 	"class": "dashboard-analytics/widgets/livewidget/features/summary/SummaryFeature"
	// }
	return [];
});
